export const canCreatorDeleteEvent = (event) => {
  if (!event || String(event.status || "").toLowerCase() === "live") return false;
  const revenue = Number(event.total_revenue);
  const madeNoMoney = event.total_revenue !== undefined && Number.isFinite(revenue) && revenue === 0;
  return madeNoMoney || event.payout_processed === true;
};
